import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "overview"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#example-7" }),
  /*#__PURE__*/_createTextVNode(" Tags with custom tags slot ")
], -1)
const _hoisted_3 = { class: "py-5" }
const _hoisted_4 = { class: "bg-dark text-white rounded-1 mb-2 p-3" }
const _hoisted_5 = { class: "multiselect-tag is-user" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_CodeHighlighter2 = _resolveComponent("CodeHighlighter2")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, " Data: " + _toDisplayString(_ctx.example7.value), 1),
      _createVNode(_component_Multiselect, _mergeProps({
        modelValue: _ctx.example7.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.example7.value = $event))
      }, _ctx.example7), {
        tag: _withCtx(({ option, handleTagRemove, disabled }) => [
          _createVNode("div", _hoisted_5, [
            _createVNode("img", {
              src: option.image
            }, null, 8, ["src"]),
            _createTextVNode(" " + _toDisplayString(option.name) + " ", 1),
            (!disabled)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                  onMousedown: _withModifiers(($event: any) => (handleTagRemove(option, $event)), ["prevent","stop"])
                }, null, 40, ["onMousedown"]))
              : _createCommentVNode("", true)
          ])
        ]),
        option: _withCtx(({ option }) => [
          _createVNode("img", {
            class: "user-image",
            src: option.image
          }, null, 8, ["src"]),
          _createTextVNode(" " + _toDisplayString(option.name), 1)
        ]),
        _: 1
      }, 16, ["modelValue"]),
      _createVNode(_component_CodeHighlighter2, null, {
        html: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.htmlCode), 1)
        ]),
        js: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.jsCode), 1)
        ]),
        _: 1
      })
    ])
  ]))
}